module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Fc-Gd-Hc-Ib-Ja.0ad54374.png";